<template>
  <v-container fluid class="px-0">
    <div class="creativeproject-page">
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-card class="folder-card ma-1">
            <v-card-text class="pa-5 pt-0">
              <v-row justify="center" style="margin-top: 5px;">
                <v-col cols="12" md="12">
                  <v-row>
                    <v-col md="11">
                      <p class="text-h5">{{ initvalue.projectname }}</p>
                    </v-col>
                    <v-col md="1" align="right">
                      <v-btn
                      class="button-shadow"
                      color="primary"
                     @click="Done"
                      >
                        Done
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="no-gutters" style="margin-left: 5px;">
                <v-col cols="12" md="2">
                  <div style="align-content: top;">
                    <v-img
                        v-if="initvalue.projectimage" 
                        v-bind:src="initvalue.projectimage"
                        max-height="170"
                        max-width="170"
                        contain
                    ></v-img>
                  </div>
                </v-col>
                <v-col cols="12" md="10">
                  <v-row class="no-gutters">
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        
                        <tr>
                          <td><span style="font-weight: 700;">Date</span></td>
                          <td>{{ new Date(initvalue.projectdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Channel</span></td>
                          <td>{{ initvalue.projectchannel }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Type</span></td>
                          <td>{{ initvalue.projecttype }}</td>
                        </tr>
                        <tr v-if="initvalue.projectchannel=='Writing'">
                          <td><span style="font-weight: 700;">Language</span></td>
                          <td>{{ initvalue.languagecode }}</td>
                        </tr>
                        <tr v-if="initvalue.projectchannel=='Design'">
                          <td><span style="font-weight: 700;">Format</span></td>
                          <td>{{ initvalue.projectformat }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Marketing</span></td>
                          <td>{{ initvalue.mktprojectname }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Business</span></td>
                          <td>{{ initvalue.bizprojectid }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td style="vertical-align: text-top;"><span style="font-weight: 700;">Requestor</span></td>
                          <td>
                            <p class="two-line">{{ initvalue.requestorname }}</p>
                          </td>
                        </tr>
                        <tr>
                          <td style="vertical-align: text-top;"><span style="font-weight: 700;">Creator</span></td>
                          <td>
                            <p class="two-line">{{ initvalue.creatorname }}</p>
                          </td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Complete By</span></td>
                          <td>{{ new Date(initvalue.projectreqdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                      </table>
                    </v-col>
                  </v-row>
                  <v-row class="no-gutters" style="margin-top: 10px;">
                    <v-col cols="12" md="12">
                      <v-row class="ma-0">
                        <p class="two-line" style="font-weight: 800;"><u>Project Description</u></p>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col>
                          <p v-html="initvalue.projectdesc.replaceAll('<p>','<p class=two-line>')"></p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <div style="margin-bottom: 5px;">&nbsp;</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1">
                <v-card-text class="pa-5 pt-0">
                  <v-tabs color="primary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-messages'"
                    >
                      Messages
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-media'"
                    >
                      Media
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-times'"
                    >
                      Time
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-messages'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                    <v-divider></v-divider>
                      <v-row justify="center" style="margin-top: 15px; margin-left: 5px;">
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col md="10">
                                <p class="text-h6">Messages</p>
                              </v-col>
                              <v-col md="2" align="right">
                                <v-btn
                                  v-if="initvalue.projectstatus!=='Completed'"
                                  class="button-shadow"
                                  color="secondary"
                                  @click="isAddMessage=true"
                                >
                                  Send
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-form>
                            </v-form>
                          </v-col>
                        </v-row>
                        <v-row no-gutters class="d-flex align-center mt-8 mb-3 px-5 py-1 mx-1">
                          <v-col v-if="messages.length==0">
                            <v-list two-line>
                              <v-list-item
                                  style="min-height: 10px;"
                                  class="px-0"
                                >
                                  <v-list-item-avatar class="my-0 text-right align-self-start" style="width: 50px; height: 50px;">
                                    <v-img src="@/assets/accountxc_icon_logo.png"></v-img>
                                  </v-list-item-avatar>

                                  <v-list-item-content class="py-0" style="vertical-align: text-top;">
                                    <v-list-item-title class="font-weight-bold greyBold--text">AccountXC</v-list-item-title>
                                    <v-list-item-subtitle class="greyBold--text fs-base text-wrap">Write a message about project details, updates, and revisions here...</v-list-item-subtitle>
                                  </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-col>
                          <v-col cols="12"  v-for="(item, i) in messages" :key="i">
                            <v-list>
                              <v-list-item
                                  style="min-height: 10px;"
                                  class="px-0"
                                >
                                  <v-list-item-avatar v-if="item.userid!=null" class="my-0 text-right align-self-start" style="width: 50px; height: 50px;">
                                    <v-img :src="data_users.length>0 ? data_users.find(user=>user._id==item.userid)['userimage'] : ''"></v-img>
                                  </v-list-item-avatar>
                                  <v-list-item-avatar v-else class="my-0 text-right align-self-start" style="width: 50px; height: 50px;">
                                    <v-img src="@/assets/accountxc_icon_logo.png"></v-img>
                                  </v-list-item-avatar>

                                  <v-list-item-content class="py-0" style="vertical-align: text-top;">
                                    <v-list-item-title v-if="item.userid!=null" class="font-weight-bold greyBold--text">{{ data_users.length>0 ? data_users.find(user=>user._id==item.userid)['username'] : '' }}&nbsp;&nbsp;&nbsp;<span style="font-size: small; font-weight: 400;">{{ new Date(item.messagedate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric", hour: "numeric", minute: "numeric"}) }}</span></v-list-item-title>
                                    <v-list-item-title v-else class="font-weight-bold greyBold--text">AccountXC&nbsp;&nbsp;&nbsp;<span style="font-size: small; font-weight: 400;">{{ new Date(item.messagedate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric", hour: "numeric", minute: "numeric"}) }}</span></v-list-item-title>

                                    
                                    <v-list-item-subtitle class="greyBold--text fs-base text-wrap" v-html="item.messagetext"></v-list-item-subtitle>
                                    <v-list-item-subtitle class="fs-base text-wrap">
                                      <div v-if="item.fileurl!='' && item.fileurl!=null">
                                        <a v-if="item.filetype == 'pdf'" :href="item.fileurl" style="text-decoration: none !important">
                                        <v-icon size="20" color="primary">
                                          mdi-file-pdf-box
                                        </v-icon>
                                        <span style="font-size: small; margin-left: 5px;">{{ item.filename }}</span>
                                      </a>
                                      <a v-if="item.filetype == 'docx'" :href="item.fileurl" style="text-decoration: none !important">
                                        <v-icon size="20" color="primary">
                                          mdi-file-word-box
                                        </v-icon>
                                        <span style="font-size: small; margin-left: 5px;">{{ item.filename }}</span>
                                      </a>
                                      <a v-if="item.filetype == 'pptx'" :href="item.fileurl" style="text-decoration: none !important">
                                        <v-icon size="20" color="primary">
                                          mdi-file-powerpoint-box
                                        </v-icon>
                                        <span style="font-size: small; margin-left: 5px;">{{ item.filename }}</span>
                                      </a>
                                      <a v-if="item.filetype == 'xlsx'" :href="item.fileurl" style="text-decoration: none !important">
                                        <v-icon size="20" color="primary">
                                          mdi-file-excel-box
                                        </v-icon>
                                        <span style="font-size: small; margin-left: 5px;">{{ item.filename }}</span>
                                      </a>
                                      <a v-if="item.filetype=='jpg' || item.filetype=='png'" :href="item.fileurl" style="text-decoration: none !important">
                                        <v-icon size="20" color="primary">
                                          mdi-image
                                        </v-icon>
                                        <span style="font-size: small; margin-left: 5px;">{{ item.filename }}</span>
                                      </a>
                                      </div>
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                  <v-list-item-action>
                                    <v-btn
                                    v-if="userid==item.userid"
                                    icon
                                    color="primary"
                                    @click="deleteProjectMessage(item)"
                                  >
                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>
                                  </v-list-item-action>
                              </v-list-item>
                            </v-list>
                          </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="2"
                      :value="'tab-media'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                    <v-divider></v-divider>
                      <v-row justify="center" style="margin-top: 15px; margin-left: 5px;">
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col md="10">
                                <p class="text-h6">Media</p>
                              </v-col>
                              <v-col md="2" align="right">
                                <v-btn
                                  v-if="isAddEnabled"
                                  class="button-shadow"
                                  color="secondary"
                                  @click="isAddMedia=true"
                                >
                                  Upload
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-form>

                            </v-form>
                          </v-col>
                        </v-row>
                        <v-form>
                              <v-data-table
                                sort-by="createdAt"
                                sort-desc
                                :headers="fileHeaders"
                                :items="medias"
                                :items-per-page="500"
                                :footer-props="footer"
                                class="elevation-0"
                              >
                                <template v-slot:top>
                                  <v-dialog v-model="isDeleteMedia" width="500">
                                    <v-card>
                                      <v-card-title> Delete this File? </v-card-title>
                                      <v-card-text>
                                        {{delete_media.medianame}}
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          outlined
                                          @click="isDeleteMedia = false"
                                          >Cancel</v-btn
                                        >
                                        <v-btn
                                          color="secondary"
                                          class="button-shadow"
                                          @click="deleteProjectMedia(delete_media)"
                                          >Delete
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </template>
                                <template v-slot:item.filetype="{ item }">
                                  <div v-if="item.fileurl!='' && item.fileurl!=null">
                                    <a v-if="item.filetype == 'pdf'" :href="item.fileurl" style="text-decoration: none !important">
                                    <v-icon size="50" color="primary">
                                      mdi-file-pdf-box
                                    </v-icon>
                                  </a>
                                  <a v-if="item.filetype == 'docx'" :href="item.fileurl" style="text-decoration: none !important">
                                    <v-icon size="50" color="primary">
                                      mdi-file-word-box
                                    </v-icon>
                                  </a>
                                  <a v-if="item.filetype == 'pptx'" :href="item.fileurl" style="text-decoration: none !important">
                                    <v-icon size="50" color="primary">
                                      mdi-file-powerpoint-box
                                    </v-icon>
                                  </a>
                                  <a v-if="item.filetype == 'xlsx'" :href="item.fileurl" style="text-decoration: none !important">
                                    <v-icon size="50" color="primary">
                                      mdi-file-excel-box
                                    </v-icon>
                                  </a>
                                  <a v-if="item.filetype=='jpg' || item.filetype=='png'" :href="item.fileurl" style="text-decoration: none !important">
                                    <v-icon size="50" color="primary">
                                      mdi-image
                                    </v-icon>
                                  </a>
                                  </div>
                                  <div v-if="item.medialink!='' && item.medialink!=null">
                                    <a v-if="item.medialink!=''" :href="item.medialink" target="_blank" style="text-decoration: none !important">
                                    <v-icon size="50" color="primary">
                                      mdi-file-cloud
                                    </v-icon>
                                  </a>
                                  </div>
                                </template>
                            <template v-slot:item.filesize="{ item }">
                              {{ item.filesize!=null ? (item.filesize / 1000).toFixed(0) + " KB" : ''}}
                            </template>   
                            <template v-slot:item.medianame="{ item }">
                              <p class="two-line">{{ item.mediatype }} ({{ item.filetype!='' ? item.filetype : item.medialink!='' && item.medialink!='' ? 'link' : '' }})</p>
                              <p class="two-line">{{ item.medianame }}</p>
                            </template>                    
                                <template v-slot:item.createdAt="{ item }">
                                  {{
                                    new Date(item.createdAt).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric", hour: "numeric", minute: "numeric"})
                                  }}
                                </template>
                                <template v-slot:item.actions="{ item }">
                                  <v-btn
                                    v-if="isAddEnabled"
                                    icon
                                    color="primary"
                                    @click="deleteProjectMediaDialog(item)"
                                  >
                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>
                                  <v-btn
                                    v-if="item.fileurl!='' && item.fileurl!=null"
                                    icon
                                    download
                                    color="primary"
                                    :href="item.fileurl"
                                  >
                                    <v-icon>mdi-download</v-icon>
                                  </v-btn>
                                  <v-btn
                                    v-if="item.medialink!='' && item.medialink!=null"
                                    icon
                                    color="primary"
                                    :href="item.medialink"
                                    target="_blank"
                                  >
                                    <v-icon>mdi-cloud</v-icon>
                                  </v-btn>
                                </template>
                                
                              </v-data-table>
                            </v-form>
                    </v-tab-item>
                    <v-tab-item
                      :key="3"
                      :value="'tab-times'"
                    >
                    <v-divider></v-divider>
                        <v-row justify="center" style="margin-top: 5px; margin-left: 5px;">
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col md="11">
                                <p class="text-h6">Time</p>
                              </v-col>
                              <v-col md="1" align="right">
                                <v-btn
                                  v-if="isAddEnabled"
                                  class="button-shadow"
                                  color="secondary"
                                  @click="isAddTime = true"
                                >
                                  Add
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-form>
                              <v-data-table
                                sort-by="timestart"
                                sort-desc
                                :headers="timeHeaders"
                                :items="times"
                                :items-per-page="500"
                                :footer-props="footer"
                                class="elevation-0"
                              >
                                <template v-slot:top>
                                  <v-dialog v-model="isDeleteTime" width="500">
                                    <v-card>
                                      <v-card-title> Delete this Time? </v-card-title>
                                      <v-card-text>
                                        {{
                                          new Date(delete_time.timestart).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric", hour: "numeric", minute: "numeric"})
                                        }}
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          outlined
                                          @click="isDeleteTime = false"
                                          >Cancel</v-btn
                                        >
                                        <v-btn
                                          color="secondary"
                                          class="button-shadow"
                                          @click="deleteProjectTime(delete_time)"
                                          >Delete
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </template>                    
                                <template v-slot:item.timestart="{ item }">
                                  {{
                                    new Date(item.timestart).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric", hour: "numeric", minute: "numeric"})
                                  }}
                                </template>
                                <template v-slot:item.timeend="{ item }">
                                  {{
                                    new Date(item.timeend).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric", hour: "numeric", minute: "numeric"})
                                  }}
                                </template>
                                <template v-slot:item.actions="{ item }">
                                  <v-btn
                                    v-if="isAddEnabled"
                                    icon
                                    color="primary"
                                    @click="deleteProjectTimeDialog(item)"
                                  >
                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>
                                </template>
                              </v-data-table>
                            </v-form>
                          </v-col>
                        </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-dialog
        v-model="isAddTime"
        persistent
        width="600px"
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Time</span>
          </v-card-title>
          <v-card-text>
            <v-container>

              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="getDates()"
                    v-model="add_time.startdate"
                    v-bind:error="errorindex == 0"
                    dense
                    persistent-hint
                    single-line hint="Start date"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="getHours()"
                    v-model="add_time.starthour"
                    v-bind:error="errorindex == 1"
                    dense
                    persistent-hint
                    single-line hint="Start hour"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="getMinutes()"
                    v-model="add_time.startminute"
                    v-bind:error="errorindex == 2"
                    dense
                    persistent-hint
                    single-line hint="Start minute"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="['AM', 'PM']"
                    v-model="add_time.startampm"
                    v-bind:error="errorindex == 3"
                    dense
                    persistent-hint
                    single-line hint="Am or Pm"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="getDates2()"
                    v-model="add_time.enddate"
                    v-bind:error="errorindex == 4"
                    dense
                    persistent-hint
                    single-line hint="End date"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="getHours()"
                    v-model="add_time.endhour"
                    v-bind:error="errorindex == 5"
                    dense
                    persistent-hint
                    single-line hint="End hour"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="getMinutes()"
                    v-model="add_time.endminute"
                    v-bind:error="errorindex == 6"
                    dense
                    persistent-hint
                    single-line hint="End minute"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="['AM', 'PM']"
                    v-model="add_time.endampm"
                    v-bind:error="errorindex == 7"
                    dense
                    persistent-hint
                    single-line hint="Am or Pm"
                  >
                  </v-select>
                </v-col>


                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="getPercentages()"
                    v-model="add_time.projectprogress"
                    v-bind:error="errorindex == 8"
                    dense
                    persistent-hint
                    single-line hint="Project Completion"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                    dense
                    v-model="add_time.timedesc"
                    label="Description"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTime=false; add_time={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addProjectTimeRequest"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddMessage"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                <p class="two-line text-h5">{{ `Send ${isSystemEnabled==true ? 'System': ''} Message` }}</p>
              </v-col>
            </v-row>

          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="add_message.messagetext"
                    v-bind:error="errorindex == 21"
                    rows=3
                    label="Message"
                    required
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="12">
                  <v-file-input 
                    label="Attach File" 
                    v-on:change="onChangeMessageFile" 
                    v-bind:error="errorindex == 22"
                    persistent-hint
                    hint="docx, gif, jpg, pdf, png, pptx, xlsx"
                    accept="
                    .docx, .xlsx, .pptx,
                    .jpg, .jpeg, .gif, .png,
                    application/pdf,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                    image/jpg, image/gif, image/png, image/jpeg
                    "                  
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddMessage=false; add_message={}; message_file=null"
            >
              Close
            </v-btn>
            <v-btn
              :disabled="add_message.messagetext!=null && add_message.messagetext.length<1"
              color="blue darken-1"
              text
              @click="insertMessage"
            >
              Send
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddMedia"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                <p class="two-line text-h5">Upload Media File</p>
                <p v-show="errortime" style="color: red; font-size: small; margin-bottom: 10px;">Error: Project times must be entered before uploading final files.</p>
              </v-col>
            </v-row>

          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-select
                    class="mb-4"
                    :items="['File', 'Link']"
                    v-model="uploadtype"
                    dense
                    persistent-hint
                    single-line hint="File Format"
                  >
                  </v-select>
                </v-col>
                <v-col v-if="uploadtype=='File'" cols="12" md="12">
                  <v-file-input 
                    label="File input" 
                    dense 
                    v-on:change="onChangeFile" 
                    v-bind:error="errorindex == 11"
                    persistent-hint
                    hint="docx, gif, jpg, pdf, png, pptx, xlsx"
                    accept="
                    .docx, .xlsx, .pptx,
                    application/pdf,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                    image/jpg, image/gif, image/png,
                    "
                  />
                </v-col>
                <v-col v-if="uploadtype=='Link'" cols="12" md="12">
                  <v-text-field
                    v-model="add_media.medialink"
                    v-bind:error="errorindex == 11"
                    label="Link"
                    required
                    dense
                    persistent-hint
                    single-line hint="One Drive or Google Drive link"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-select
                    class="mb-4"
                    :items="['Draft File', 'Final File']"
                    v-model="add_media.mediatype"
                    v-bind:error="errorindex == 12"
                    dense
                    persistent-hint
                    single-line hint="Media Type"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="add_media.medianame"
                    v-bind:error="errorindex == 13"
                    label="Media Name"
                    required
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddMedia = false; add_media={}; media_file=null"
            >
              Close
            </v-btn>
            <v-btn
              :disabled="media_file==null && add_media.medialink==null"
              color="blue darken-1"
              text
              @click="insertMedia"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Profile",

  data() {
    return {
      error: undefined,
      errortag: false,
      errortime: false,
      errorindex: undefined,
      isAddMedia: false,
      isAddMessage: false,
      isAddTime: false,
      isAddEnabled: false,
      isSystemEnabled: false,
      isDeleteMedia: false,
      isDeleteMessage: false,
      isDeleteTime: false,
      uploadtype: 'File',
      media_file: null,
      message_file: null,
      userid: null,

      initvalue: {},
      
      delete_media: {},
      delete_message: {},
      delete_time: {},

      add_message: {},
      add_media: {},
      add_time: {},
      
      
      mktprojects: [],
      messages: [],
      medias: [],
      times: [],
      data_users: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      

      timeHeaders: [
        { text: "Start", value: "timestart", width: "20%"},
        { text: "End", value: "timeend", width: "20%" },
        { text: "Work Hours", value: "timehour", width: "10%" },
        { text: "Desc", value: "timedesc" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      fileHeaders: [
        { text: "Type", value: "filetype", width: "10%" }, 
        { text: "Name", value: "medianame" },
        { text: "Size", value: "filesize", width: "10%" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
    };
  },
  computed: {
    ...mapState('CreativeProject', ['isReceiving']),
    ...mapState('Language', ['languages']),
  },
  methods: {
    ...mapActions('MarketProject', ['getMarketProjectsAllRequest']),
    ...mapActions('CreativeProject', ['getCreativeProjects', 
                    'insertProjectMessageRequest', 'insertProjectSystemMessageRequest', 'insertProjectSystemMessageWithFileRequest', 
                    'insertProjectMessageWithFileRequest',
                    'insertProjectMediaRequest', 'insertProjectMediaWithFileRequest','insertProjectTimeRequest',
                    'deleteProjectMessageRequest', 'deleteProjectMediaRequest', 'deleteProjectTimeRequest']),
    ...mapActions('User', ['getUsersAllRequest']),
    checkError(){
      if(!this.add_time.startdate){
        this.errortag = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.add_time.starthour){
        this.errortag = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.add_time.startminute){
        this.errortag = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.add_time.startampm){
        this.errortag = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.add_time.enddate){
        this.errortag = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.add_time.endhour){
        this.errortag = true;
        this.errorindex = 5;
        return false;
      }
      if(!this.add_time.endminute){
        this.errortag = true;
        this.errorindex = 6;
        return false;
      }
      if(!this.add_time.endampm){
        this.errortag = true;
        this.errorindex = 7;
        return false;
      }
      if(!this.add_time.projectprogress){
        this.errortag = true;
        this.errorindex = 8;
        return false;
      }

      this.errorindex = -1;
      return true;
    },
    checkError2(){
      if(this.uploadtype=='File' && this.media_file==null){
        this.errortag = true;
        this.errorindex = 11;
        return false;
      }
      if(this.uploadtype=='Link' && !this.add_media.medialink){
        this.errortag = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.add_media.mediatype){
        this.errortag = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.add_media.medianame){
        this.errortag = true;
        this.errorindex = 13;
        return false;
      }
      if(this.add_media.mediatype=='Final File' && this.times.length==0){
        this.errortime = true;
        return false;
      }
      this.errortime = false;
      this.errorindex = -1;
      return true;
    },
    checkError3(){
      if(!this.add_message.messagetext){
        this.errortag = true;
        this.errorindex = 21;
        return false;
      }
      this.errortime = false;
      this.errorindex = -1;
      return true;
    },
    Done() {
      if(this.initvalue._isFrom!==undefined) this.$router.replace({ name: this.initvalue._isFrom });
      else this.$router.replace({ name: 'Dashboard' });
    },
    getDates(){
      let results = [];
      let now = new Date(); 
      var today = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+ now.getDate(); 
      
      for(var i=0; i<7; i++){
        let now = new Date(new Date(today).getTime()-(i*24*60*60*1000));
        let date = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+ now.getDate();
        results.push(date);
      }
      return results;
    },
    getDates2(){
      if(this.add_time.startdate!=null) return [this.add_time.startdate];
      else return [];
    },
    getHours(){
      let results = [];
      
      for(var i=1; i<=12; i++){
        results.push(i.toString());
      }
      return results;
    },
    getMinutes(){
      let results = [];
      
      for(var i=0; i<=55; i+=5){
        let result;
        if(i<=9) result = '0' + i.toString();
        else result = i.toString();
        results.push(result);
      }
      return results;
    },
    getPercentages(){
      let results = [];
      
      for(var i=0; i<=100; i+=5){
        let result = {text: i.toString()+'%', value: i};
        results.push(result);
      }
      return results;
    },
    async addProjectTimeRequest() {
      if(!this.checkError()) return;
      this.isAddTime = false;
      this.add_time.id = this.initvalue._id;
      let result = await this.insertProjectTimeRequest(this.add_time);
      this.times.push(result);
      this.add_time = {};
    },

    deleteProjectTimeDialog(item) {
      this.isDeleteTime = true;
      this.delete_time = {
        _id: item._id,
        timestart: item.timestart,
      };
    },
    deleteProjectMediaDialog(item) {
      this.isDeleteMedia = true;
      this.delete_media = {
        _id: item._id,
        medianame: item.medianame,
      };
    },
    async deleteProjectTime(payload) {
      this.isDeleteTime = false;
      let response = await this.deleteProjectTimeRequest(payload);
      let index = this.times.findIndex((trans) => trans._id == response._id);
      this.times.splice(index, 1);
    },
    async deleteProjectMedia(payload) {
      this.isDeleteMedia = false;
      let response = await this.deleteProjectMediaRequest(payload);
      let index = this.medias.findIndex((trans) => trans._id == response._id);
      this.medias.splice(index, 1);
    },
    async deleteProjectMessage(payload) {
      let response = await this.deleteProjectMessageRequest(payload);
      let index = this.messages.findIndex((trans) => trans._id == response._id);
      this.messages.splice(index, 1);
    },
    onChangeFile(file) {
      console.log(file)
      if (!file) this.media_file.file = null;
      else this.media_file = file;
    },
    onChangeMessageFile(file) {
      if (!file) this.message_file.file = null;
      else this.message_file = file;
    },
    async insertMessage() {
      if(!this.checkError3()) return;
      this.isAddMessage = false;
      this.add_message.id = this.initvalue._id;
      let result;
      if(this.isSystemEnabled==true){
        if(this.message_file!=null){
          this.add_message.file = this.message_file;
          this.add_message.filename = this.message_file!=null ? this.message_file.name : '';
          result = await this.insertProjectSystemMessageWithFileRequest(this.add_message);
        } 
        else {
          this.add_message.file = null;
          result = await this.insertProjectSystemMessageRequest(this.add_message);
        } 
      }
      else if(this.message_file!=null){
        console.log(this.message_file)
        this.add_message.file = this.message_file;
        this.add_message.filename = this.message_file!=null ? this.message_file.name : '';
        result = await this.insertProjectMessageWithFileRequest(this.add_message);
      } 
      else {
        this.add_message.file = null;
        result = await this.insertProjectMessageRequest(this.add_message);
      } 
      this.messages = [result, ...this.messages];
      this.add_message = {};
      this.message_file = null;

    },
    async insertMedia(){
      if(!this.checkError2()) return;
      this.isAddMedia = false;
      this.add_media.id = this.initvalue._id;

      if(this.uploadtype=='File'){
        this.add_media.medialink = null;
        delete this.add_media['medialink'];
        this.add_media.file = this.media_file;
        this.add_media.filename = this.media_file!=null ? this.media_file.name : '';
      }
      else{
        this.add_media.file = null;
        delete this.add_media['file'];
      }
      let media;

      if(this.add_media.file!=undefined && this.add_media.file!=null) media = await this.insertProjectMediaWithFileRequest(this.add_media);
      else media = await this.insertProjectMediaRequest(this.add_media);
      this.medias.push(media);
      this.add_media = {};
      this.media_file = null;
      this.uploadtype = 'File';
    },
  },
  async created() {
    this.userid = localStorage.getItem('userid');
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.replace({ name: "Dashboard" });
    this.messages = this.initvalue.messages;
    this.medias = this.initvalue.medias;
    this.times = this.initvalue.times;
    if(this.messages && this.messages.length>0){
      this.messages.sort((a,b) =>{
      if (b.createdAt < a.createdAt) return -1;
      if (a.createdAt > b.createdAt) return 1;
      return 0;
    });
    }
    if(this.initvalue.projectstatus!=='Completed' && this.initvalue.repid==this.userid) this.isAddEnabled = true;
    if(this.initvalue._isFrom =='CreativeProjectTeamList') this.isSystemEnabled = true;
    
    this.data_users = await this.getUsersAllRequest();
  },
};
</script>

<style src="./View.scss" lang="scss"/>
